export default __webpack_public_path__ + "97c11990c1e1747384df9d0f4f7bd2ba.png";